/** @format */

import React from 'react';
import { safeUrl } from '../../../services/drupal-services';

interface FooterLinkProps {
  link: string;
  name: string;
  external: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  submenu: React.ReactElement<any, any> | null;
}

/**
 * Footer Link.
 *
 * @param {string} link
 * @param {string} name
 * @param {number} external
 */
const FooterLink = ({
  link,
  name,
  external,
  submenu,
}: FooterLinkProps): JSX.Element => {
  const subNavigation =
    submenu !== null ? <ul className="submenu">{submenu}</ul> : null;
  const externalLink: boolean = external === '1';
  return (
    <li>
      <a
        href={safeUrl(link)}
        target={externalLink ? '_blank' : '_self'}
        rel={externalLink ? 'noreferrer noopener' : ''}>
        {name}
      </a>
      {subNavigation}
    </li>
  );
};
export default FooterLink;
